import * as itemTypes from '../../items/item-types';

export const START = 'start';
export const STOP = 'stop';
export const PAGE = itemTypes.PAGE;
export const CONDITION = 'condition';
export const REFRESH_CONTEXT = 'refreshContext';
export const EVENT_TRACKER = 'eventTracker';
